import { Component, Input, output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { GasMeter } from 'src/app/models/gas-meter.model';
import { Unit } from 'src/app/models/unit.model';
import { SettlementsService } from 'src/app/services/settlements.service';

@Component({
  selector: '[app-form-custom-gas-meter-read]',
  template: `
    <div class="d-flex">
      <div class="flex-fill">
        <p>{{gas_meter?.meter_code}} <span class="badge bg-secondary ms-2">{{gas_meter?.meter_brand}}</span></p>
      </div>
      <div>
        <p class="text-sm">Última lectura: {{gas_meter?.last_read}}</p>
      </div>
    </div>
    <div class="d-flex edit-meter" *ngIf="!created">
      <div class="flex-fill">
        <form [formGroup]="gas_meter_form" class="form-horizontal">
          <div class="form-group">
            <label for="read_curr" class="form-control-label">Litros consumidos</label>
            <input type="number" formControlName="consumo_lt" class="form-control">
          </div>
        </form>
      </div>
      <div class="mt-4 ms-2">
        <button type="submit" class="btn btn-zazz-dark" (click)="onSubmit()">Agregar</button>
      </div>
    </div>
  `,
  styles: ``
})
export class FormCustomGasMeterReadComponent {
  @Input() gas_meter: GasMeter | null = null;
  @Input() unit: Unit | null = null;
  gasMeterAdded = output();

  gas_meter_form: FormGroup = new FormGroup({});
  loading: boolean = false;

  created: boolean = false;

  constructor(
    private fb: FormBuilder,
    private store: SettlementsService,
    private toastr: ToastrService
  ) {
    // Initialize the form group with the necessary controls
    this.gas_meter_form = this.fb.group({
      consumo_lt: [''],
      unit_id: [''],
      gas_meter_id: [''],
    });
  }

  onSubmit() {

    console.log('onSubmit => ', this.gas_meter_form.value);

    this.gas_meter_form.patchValue({
      unit_id: this.unit?.id,
      gas_meter_id: this.gas_meter?.id
    });

    this.store.createGasMeterRead(this.gas_meter_form.value).subscribe({
      next: (data: any) => {
        console.log('createGasMeterRead => ', data);
        this.gasMeterAdded.emit(data);
      },
      error: (err: any) => {
        console.log('createGasMeterRead ERROR => ', err);
        this.toastr.error('Ocurrió un error al crear la lectura del medidor', 'Error');
        this.loading = false;
        return;
      }
    });
  }

  onSubmitPromise() {
    console.log('onSubmit => ', this.gas_meter_form.value);

    this.gas_meter_form.patchValue({
      unit_id: this.unit?.id,
      gas_meter_id: this.gas_meter?.id
    });

    const obs$ = this.store.createGasMeterRead(this.gas_meter_form.value);
    return firstValueFrom(obs$);
  }
}
